<template>
  <!-- zIndex100 -->
  <div class="header zIndex100">
    <div class="user">
      <div class="user__info" v-if="!JSON.parse(GET_USERINFO).token" @click="Login">
        <div class="user__info_login font16">登录</div>
        <div class="user__info_registered font16">注册</div>
      </div>
      <div class="setting" v-else>
        <div class="text-white setting_user">
          <span class="h5">Hi,</span>
        </div>
        <el-popover
          placement="bottom"
          width="100"
          trigger="hover"
          popper-class="popover_drop"
          :close-delay="0"
          :visible-arrow="false"
        >
          <ul
            class="setting_drop_down text-center"
            @mouseover="showDropDown=true"
            @mouseleave="showDropDown=false"
          >
            <li @click="searchOrder">
              <span>我的订单</span>
            </li>
            <li>
              <router-link to="/setting-password">账号设置</router-link>
            </li>
            <el-divider></el-divider>
            <li @click="loginOut">
              <span>退出登录</span>
            </li>
          </ul>
          <div
            slot="reference"
            class="outBtn text-white"
            @mouseover="showDropDown=true"
            @mouseleave="showDropDown=false"
          >
            <i>{{JSON.parse(GET_USERINFO).mobile}}</i>
            <i class="pullWidth" :class="showDropDown?'up':'pull'"></i>
          </div>
        </el-popover>
      </div>

      <div class="user__info_img">
        <!-- <img
          class="user__info_cart"
          src="https://static.zc0901.com/dci-web-shop-cart.png"
          @click="shopCart"
        /> -->
        <div class="user__info_list"
          v-if="showMenu"
          @click="menu">
            <div></div>
            <div></div>
            <div></div>
        </div>
        <img
          class="user__info_list"
          v-if="!showMenu"
          src="https://static.zc0901.com/dci-web-shop-cancel.png"
          @click="cancel"
        />
      </div>
    </div>
    <img class="imola__dci_icon zIndex100" @click="goHome" src="https://static.zc0901.com/imola-dci-web-icon-new-1.png" />
  </div>
</template>

<script>
import { removeToken, getToken } from "@/utils/cookies";
import { mapGetters, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      num: 0,
      userAvatar: "https://static.zc0901.com/imola-dci-add-img.png",
      showDropDown: false
    };
  },
  computed: {
    ...mapGetters("user", ["GET_USERINFO"]),
    ...mapState("common", {
      showMenu: "showMenu"
    })
  },
  created() {},
  updated() {},
  mounted() {},
  methods: {
    ...mapMutations("common", ["setShowMenu"]),
    Login() {
      this.$router.push("/login");
    },
    loginOut() {
      this.$store.commit("user/loginout");
      this.$router.push("/login");
    },
    //查看我的订单
    searchOrder() {
      console.log("查看订单");
      this.$emit("openOrder");
    },
    // 打开🛒
    shopCart() {
      this.$emit("changeRouterFn", "shopCart");
    },
    // 打开菜单栏
    menu() {
      this.setShowMenu(false);
      this.$emit("changeRouterFn", "menu");
    },
    // 关闭菜单栏
    cancel() {
      this.setShowMenu(true);
      this.$emit("changeRouterFn", "home");
    },
    // 去首页
    goHome(){
      this.setShowMenu(true);
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
@import'../../../common/animation.scss';
.header {
  width: 100%;
  height: 100px;
  position: fixed;
  display: flex;
  align-items: center;
  min-width: 1200px;
}
.user {
  position: absolute;
  right: 80px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.user__info {
  display: flex;
  text-align: center;
  height: 16px;
  margin: auto;
  &_login {
    width: 60px;
    border-right: 1px solid rgba(204, 204, 204, 1);
  }
  &_registered {
    width: 60px;
  }
}
.user__info_avatar {
  width: 48px;
  height: 48px;
  border-radius: 48px !important;
  background: black;
}
.user__info_img {
  display: flex;
  margin-left: 10px;
  img {
    width: 32px;
    height: 32px;
  }
  .user__info_cart {
    margin-right: 8px;
  }
}
.imola__dci_icon {
  position: absolute;
  left: 80px;
  width: 100px;
  // height: 60px;
  cursor: pointer;
}
.setting {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  .pullWidth {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-size: cover;
  }
  .pull {
    background-image: url("../../../assets/images/pullup.png");
  }
  .up {
    background-image: url("../../../assets/images/pulldown.png");
  }
  &_user {
    display: flex;
    align-items: center;
  }

  &_drop {
    position: absolute;
    right: 0;
    top: 40px;
    display: flex;
    flex-direction: column;
  }
}
.user__info_list{
  width: 20px;
  height: 32px;
  position: relative;
  box-sizing: border-box;
  div{
    height: 2px;
    border-radius: 1px;
    background: white;
    margin-bottom: 5px;
  }
  div:nth-of-type(1){
    width: 12px;
    animation: div_width 1s infinite;
    margin-top: 8px;
  }
  div:nth-of-type(2){
    width: 20px;
  }
  div:nth-of-type(3){
    width: 12px;
    position: absolute;
    right: 0;
    animation: div_width 1s infinite;
  }
}
</style>
<style lang="scss">
.setting_drop_down {
  .el-divider {
    margin: 8px 0;
    background: rgba(229, 229, 229, 1);
  }
}
.popover_drop {
  width: 100px !important;
  height: 138px !important;
  min-width: 100px !important;
  padding: 0 !important;
  margin-top: 0 !important;
  // top: 75px !important;
  .setting_drop_down {
    box-sizing: border-box;
    width: 100px;
    padding: 8px 22px;
    background: #fff;
    li {
      height: 34px;
      line-height: 34px;
    }
    a {
      display: block;
      width: 100%;
      color: #333;
      font-size: 14px;
    }
    span {
      color: #333;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
.setting {
  .el-button {
    span {
      color: #fff;
    }
  }
}
.outBtn {
  height: 40px;
  padding-left:10px ;
  display: flex;
  align-items: center;
}
</style>
